// External packages
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

// Components
import { Label } from 'components/Forms';
import { Card } from 'components/Card';

// Utils
import { formatDate } from 'utils/formatDate';

export const LicenseGraph = ({ Licenses = [] }: { Licenses: any[] }) => {
  const chartData = Licenses.reduce(
    (acc: { date: string; 'Broj ulaznica': number }[], License) => {
      const date = License.redeemedAt ? formatDate(License.redeemedAt) : null;
      if (!date || date === '-') return acc;
      const existing = acc.find((entry) => entry.date === date);
      if (existing) {
        existing['Broj ulaznica'] += 1;
      } else {
        acc.push({ date, ['Broj ulaznica']: 1 });
      }
      return acc;
    },
    []
  );

  return (
    <>
      <Label>Broj iskorištenih ulaznica po danu</Label>
      <Card className="bg-white pb-1 pl-0">
        <ResponsiveContainer aspect={2} width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="Broj ulaznica"
              stroke="#3B82F6"
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>
    </>
  );
};
